




















import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { IEditableFormatQuestionnaireSubmissionAttachmentResource } from "../../../../../../domain/editableFormat";

@Component
export default class FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditableFormatQuestionnaireSubmissionAttachmentResource) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditableFormatQuestionnaireSubmissionAttachmentResource) => T, defaultValue: T) => T;

  get description(): string {
    return this.readPropertyOrDefault(s => s.description, "");
  }

  set description(value: string) {
    this.writePropertyWhenValid(s => s.description = value);
  }

  get expression(): string {
    return this.readPropertyOrDefault(s => s.expression, "");
  }

  set expression(value: string) {
    this.writePropertyWhenValid(s => s.expression = value);
  }

  @Emit()
  deleteProperty() {}
}
